import { render, staticRenderFns } from "./RoundLabelValues.vue?vue&type=template&id=7d2c8874&scoped=true"
import script from "./RoundLabelValues.vue?vue&type=script&lang=ts"
export * from "./RoundLabelValues.vue?vue&type=script&lang=ts"
import style0 from "./RoundLabelValues.vue?vue&type=style&index=0&id=7d2c8874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2c8874",
  null
  
)

export default component.exports